<template>
  <el-row style="margin: 1.25rem;">
    <div v-if="liad_show">
      <load></load>
    </div>
    <el-row v-if="type!='see'">
      <el-col :span="16" :offset="4" v-if="show=='true'" >
        <el-row style="text-align: center;">
          <h2>{{list.name}}</h2>
        </el-row>
        <el-card class="box-card" v-for="(item,index) in list.content" :key="index" style="margin-top: 1.25rem;">
          <div slot="header" class="clearfix">
            <span><span style="margin-right: 0.3125rem;font-size: 0.9375rem;">{{index+1}}.
            <span style="color: red;">*</span>
            </span>{{item.name}}</span>
            <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
          </div>
          <el-row v-if="item.type=='input'">
            <el-input    v-model="item.user_choice" placeholder="请输入内容" @input="elinput()"></el-input>
          </el-row>
          <el-row v-else v-for="(items,indexs) in item.choice" :key="indexs" class="text item" >
            <el-radio-group v-if="item.type=='radio'"  v-model="item.user_choice"@change="change1">
                <el-radio :label="items.num"  >{{items.name}}</el-radio>
              </el-radio-group>
            <!-- <el-radio v-if="item.type=='radio'"   v-model="item.user_choice" :label="items.num" @click.native="radio_click(item)">{{items.name}}</el-radio> -->
            <el-checkbox v-else  :label="indexs"  style="width: 100%;" @change="change(index, indexs)">
                    {{items.name}}
            </el-checkbox>
          </el-row>
        </el-card>
        <el-button type="success" style="width: 100%;margin-top: 1.25rem;" @click="success()">提交</el-button>
      </el-col>
    </el-row>

    <el-row v-else>
      <el-col :span="16" :offset="4" v-if="show=='true'" >
        <el-row style="text-align: center;">
          <h2>{{list.name}}</h2>
        </el-row>
        <el-card class="box-card" v-for="(item,index) in list.content" :key="index" style="margin-top: 1.25rem;">
          <div slot="header" class="clearfix">
            <span><span style="margin-right: 0.3125rem;font-size: 0.9375rem;">{{index+1}}.
            <span style="color: red;">*</span>
            </span>{{item.name}}</span>
            <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
          </div>
          <el-row v-if="item.type=='input'">
            <el-input  disabled  v-model="item.user_choice" placeholder="请输入内容" @input="elinput()"></el-input>
          </el-row>
          <el-row v-else v-for="(items,indexs) in item.choice" :key="indexs" class="text item" >
            <el-radio-group v-if="item.type=='radio'"  v-model="item.user_choice"@change="change1">
                <el-radio disabled :label="items.num"  >{{items.name}}</el-radio>
              </el-radio-group>
            <!-- <el-radio v-if="item.type=='radio'"   v-model="item.user_choice" :label="items.num" @click.native="radio_click(item)">{{items.name}}</el-radio> -->
            <!-- <el-checkbox v-else  v-model="checked" disabled :label="item.user_choice"  style="width: 100%;" >
                    {{items.name}}
            </el-checkbox> -->
            <el-checkbox-group v-else v-model="item.user_choice">
                <el-checkbox disabled :label="indexs">{{items.name}}</el-checkbox>
              </el-checkbox-group>
          </el-row>
        </el-card>
        <el-button  style="width: 100%;margin-top: 1.25rem;" @click="back()">返 回</el-button>
      </el-col>
    </el-row>

  </el-row>
</template>

<script>
  import load from "../../../components/load.vue"
  export default {
      data() {
        return {
          num:this.$route.query.num,
          type:this.$route.query.type,
          list:{},
          input:'',
          liad_show:false,
          show:false,
          }
        },
        components: {
          load:load
         },
        mounted: function (){
          if(this.type=='see'){
            this.get_see_info()
          }else{
            this.get_info();
          }

        },
        methods: {
          back(){
            this.$router.go(-1)
          },
          get_see_info(){
            let _this=this
            _this.liad_show=true
            _this.show=false
            _this.axios.get('/v2/user_inves/inves_info', {
                params: {
                  num:_this.num
                }
              }).then(function(res) {
                if (res.status == '200') {
                  if (res.data.code == '1') {
                    _this.liad_show=false
                    _this.show='true'
                    _this.list.name=res.data.data.name
                    _this.list.content=res.data.data.content
                    for(let i=0;i<_this.lisl.content.length;i++){
                      if( _this.list.content[i].hasOwnProperty('choice')){
                        for(let j=0;j<_this.list.content[i].choice.length;j++){
                          _this.list.content[i].choice[j]['num']=j
                        }
                      }
                    }
                  } else {
                    _this.$message.error(res.data.msg)
                  }
                } else {
                  _this.$message.error('服务器内部错误')
                }
              }).catch(function(error) {
                // _this.$message.error('服务器内部错误')
              });
          },
          elinput(){
            let _this=this
            this.$forceUpdate();
          },
          change(index,indexs){
            let _this=this
              if( _this.list.content[index].user_choice.indexOf(indexs)=='-1'){
                _this.list.content[index].user_choice.push(indexs)
              }else{
                _this.list.content[index].user_choice.splice(  _this.list.content[index].user_choice.indexOf(indexs),1)
              }
          },
          unique(arr) {
           const res = new Map();
           return arr.filter((arr) => !res.has(arr) && res.set(arr, 1));
          },
          success(){
            let _this=this
            for(let i=0;i<_this.list.content.length;i++){
              if(_this.list.content[i].user_choice.length==0){
                _this.$message.warning('您的['+(i+1)+']题还未作答，请抓紧作答哦！！！')
                return
              }
            }
            let data={
              num:_this.num,
              content:JSON.stringify(_this.list.content)
            }
            _this.liad_show=true
            _this.axios.post("/v2/user_inves/inves_save",{data:data}).then(function (res) {
              if(res.data.code=='1'){
                _this.liad_show=false
                _this.$message.success(res.data.msg)
                _this.type='see'
                _this.get_see_info()
                // _this.$router.go(-1)
              }else{
                _this.$message.error(res.data.msg)
                _this.liad_show=false
              }
            })
          },
          //解决单选无法选中的问题
          change1() { this.$forceUpdate() },
          radio_click(item){
            console.log(item)
          },
          get_info(){
            let _this=this
            _this.liad_show=true
            _this.axios.get('/v2/user_inves/inves_info', {
                params: {
                  num:_this.num
                }
              }).then(function(res) {
                if (res.status == '200') {
                  if (res.data.code == '1') {
                    _this.liad_show=false
                    _this.show='true'
                    _this.list.name=res.data.data.name
                    _this.list.content=res.data.data.content
                    for(let i=0;i<_this.list.content.length;i++){
                      if(_this.list.content[i].type=='checkbox'){
                        _this.list.content[i]['user_choice']=[]
                      }else{
                        _this.list.content[i]['user_choice']=_this.input
                      }
                      console.log(_this.list.content[i].hasOwnProperty('choice'))
                      if( _this.list.content[i].hasOwnProperty('choice')){
                        for(let j=0;j<_this.list.content[i].choice.length;j++){
                          _this.list.content[i].choice[j]['num']=j
                        }
                      }
                    }
                    console.log(_this.list)
                  } else {
                    _this.$message.error(res.data.msg)
                  }
                } else {
                  _this.$message.error('服务器内部错误')
                }
              }).catch(function(error) {
                _this.$message.error('服务器内部错误')
              });
          },
      }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/visitor/Task/TaskQuestionnaire.vue